var _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(0, 0, 0, 0)",
      display: "block"
    },
    width: "70px",
    height: "30px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 60,
    r: 15,
    fill: "#9C9C9C"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
    repeatCount: "indefinite",
    values: "60;40;60;60",
    keyTimes: "0;0.5;1;1",
    dur: "0.8s",
    begin: "-0.8s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 60,
    r: 15,
    fill: "#9C9C9C"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
    repeatCount: "indefinite",
    values: "60;40;60;60",
    keyTimes: "0;0.5;1;1",
    dur: "0.8s",
    begin: "-0.26666666666666666s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 60,
    r: 15,
    fill: "#9C9C9C"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
    repeatCount: "indefinite",
    values: "60;40;60;60",
    keyTimes: "0;0.5;1;1",
    dur: "0.8s",
    begin: "-0.5333333333333333s"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLoading);
export default __webpack_public_path__ + "static/media/button-loading.370735f7.svg";
export { ForwardRef as ReactComponent };